// extracted by mini-css-extract-plugin
export default {"listItem":"ContactItem_listItem__NSSYk","name":"ContactItem_name__XjpNK","number":"ContactItem_number__mfZ8x"};